import apiFetch from '../apiFetch'

export default function (token, documentTypeId, entityId) {
  return apiFetch({ endPoint: `documentHistorical?documentTypeId=${documentTypeId}&id=${entityId || 'null'}`, method: 'GET', token: token })
}
